import React from 'react'

const NewsletterTwo = () => {
    return (
        <div className="newsletter-two py-32 overflow-hidden" style={{ background: 'linear-gradient(135deg, #016935, #73B58A)' }}>
        </div>
    )
}

export default NewsletterTwo